import { Switch } from "antd";
import { ColumnsType } from "antd/es/table";
import React from "react";

import { FlagDef } from "./types";

export function getEnablementFlagsColumns(
  pendingFlag: string | null,
  onToggle: (flag: string, checked: boolean) => void
): ColumnsType<FlagDef> {
  return [
    {
      title: "FLAG",
      dataIndex: "flag",
      key: "flag",
    },
    {
      title: "STATUS",
      dataIndex: "value",
      key: "value",
      width: 120,
      render: (_: unknown, record: FlagDef) => (
        <Switch
          className="switch"
          checked={record.value}
          loading={pendingFlag === record.flag}
          onChange={(checked) => onToggle(record.flag, checked)}
        />
      ),
    },
  ];
}
